export const formatDate = (date, includeTime) => {
  const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
  const day = date.getDate().toString();
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const year = date.toLocaleDateString("en-US", { year: "numeric" });
  let time = "";
  if (includeTime) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    time = `${hours}:${minutes < 10 ? "0" + minutes : minutes}${ampm}`;
  }

  return `${weekday} ${day} ${month} ${year} ${time}`.trim();
};

export const formatDateRange = (
  start_date,
  end_date,
  remove_time_for_multiple_dates= false,
) => {
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);
  const startAndEndAreSameDate = startDate.toDateString() === endDate.toDateString();

  const includeTime =
    start_date.includes("T") && end_date.includes("T") && (startAndEndAreSameDate || !remove_time_for_multiple_dates);
  const formattedStartDate = formatDate(startDate, includeTime);
  const formattedEndDate = formatDate(endDate, includeTime);

  if (startAndEndAreSameDate) {
    if (includeTime) {
      const timePart = formattedEndDate.split(" ").slice(-1).join(" ");
      return `${formattedStartDate} - ${timePart}`;
    } else {
      return formattedStartDate;
    }
  }

  return `${formattedStartDate} - ${formattedEndDate}`;
};